<template>
  <div class="evidence-limitations-card gm-card rounded-xl pa-5 mb-4 border">
    <div class="d-flex flex-wrap align-center justify-space-between ga-2 mb-3">
      <div class="d-flex align-center ga-2">
        <div class="icon-circle bg-amber-50 d-flex align-center justify-center rounded-lg">
          <v-icon color="#d97706" size="20">mdi-shield-alert-outline</v-icon>
        </div>
        <div>
          <h3 class="text-subtitle-1 font-weight-bold text-slate-800 mb-0">
            取证边界与客观限制
          </h3>
          <div class="text-caption text-slate-500">
            法定红线要求：必须显式展开 · 客观限制绝不代表现场无异常
          </div>
        </div>
      </div>

      <span class="text-caption font-weight-bold px-2-5 py-1 rounded-lg bg-red-50 text-red-darken-3 border border-red-200">
        <v-icon size="14" class="mr-0-5">mdi-alert</v-icon>
        排障须知：云端数据未还原瞬间不等于误报
      </span>
    </div>

    <div class="d-flex flex-wrap ga-4">
      <!-- 左栏：已确证的客观事实 -->
      <div class="fact-column flex-grow-1 flex-basis-0 pa-4 rounded-xl border bg-slate-50">
        <div class="d-flex align-center ga-2 mb-3">
          <v-icon color="#16a34a" size="18">mdi-check-decagram</v-icon>
          <span class="font-weight-bold text-body-2 text-slate-800">已被数据支持的客观事实</span>
        </div>
        <div v-if="verifiedFacts.length" class="fact-list d-flex flex-column ga-2">
          <div
            v-for="(fact, fIdx) in verifiedFacts"
            :key="fIdx"
            class="fact-item d-flex align-start ga-2 text-body-2 text-slate-700"
          >
            <span class="fact-bullet flex-shrink-0">✓</span>
            <span>{{ fact }}</span>
          </div>
        </div>
        <div v-else class="text-caption text-slate-400 py-2">
          暂无已确证事实记录
        </div>
      </div>

      <!-- 右栏：本次取证边界与客观限制清单 -->
      <div class="limitation-column flex-grow-1 flex-basis-0 pa-4 rounded-xl border bg-amber-50">
        <div class="d-flex align-center justify-space-between ga-2 mb-3">
          <div class="d-flex align-center ga-2">
            <v-icon color="#d97706" size="18">mdi-alert-octagon-outline</v-icon>
            <span class="font-weight-bold text-body-2 text-amber-darken-4">客观取证盲区与限制清单</span>
          </div>
          <span class="text-caption text-amber-darken-3 font-weight-bold">共 {{ limitations.length }} 项</span>
        </div>
        <div v-if="limitations.length" class="limitation-list d-flex flex-column ga-2-5">
          <div
            v-for="(item, idx) in limitations"
            :key="idx"
            class="limitation-item d-flex align-start ga-2-5 text-body-2 text-slate-800"
          >
            <span class="limitation-badge flex-shrink-0">{{ idx + 1 }}</span>
            <span class="lh-base">{{ item }}</span>
          </div>
        </div>
        <div v-else class="text-caption text-slate-400 py-2">
          暂无额外限制清单
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue'

const props = defineProps({
  analysis: { type: Object, default: null },
})

const limitations = computed(() => {
  return props.analysis?.coverageLimitations || []
})

const verifiedFacts = computed(() => {
  return props.analysis?.verifiedFacts || []
})
</script>

<style scoped lang="scss">
.evidence-limitations-card {
  background: #ffffff;
  border-color: #e2e8f0;
  box-shadow: 0 2px 12px rgba(15, 23, 42, 0.04);
}

.icon-circle {
  width: 36px;
  height: 36px;
}

.border-red-200 {
  border-color: #fecaca !important;
}

.fact-column {
  border-color: #e2e8f0;
}

.fact-bullet {
  color: #16a34a;
  font-weight: bold;
}

.limitation-column {
  border-color: #fde68a !important;
}

.limitation-badge {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 18px;
  height: 18px;
  border-radius: 50%;
  background: #fef3c7;
  color: #b45309;
  font-size: 11px;
  font-weight: bold;
  border: 1px solid #fde68a;
  margin-top: 1px;
}
</style>
